module.exports = __webpack_public_path__ + "static/media/tm6_1.1d5d5a53.svg";